import { UploadFile } from 'features/NktFileUploader/types';
import * as api from 'services/api.service';
import { DownloadFileType, downloadFile } from 'services/fileDownload.service';
import config from 'shared/config';
import { FileDescriptor, FileTypes, MimeTypeKeys, MimeTypeMap, MimeTypeValues } from 'types/fileTypes';

const MAX_FILE_SIZE_MB = 100;

export const isMediaFile = (fileType: MimeTypeValues): boolean =>
  fileType === FileTypes.video || fileType === FileTypes.image;

export function getFileType(mimeType: string): number {
  return mimeType in MimeTypeMap ? MimeTypeMap[mimeType as MimeTypeKeys] : FileTypes.defaultFile;
}

export function resetFileInput(id: string): void {
  const fileInput = document.getElementById(id) as HTMLInputElement | null;
  if (fileInput) {
    fileInput.value = '';
  }
}

export const getFileUploadLink = (fileUpload: UploadFile): string | undefined => {
  let link: string | undefined = undefined;
  if (fileUpload.objFile) {
    link = `${config.apiUrl}/files/${fileUpload.objFile.id}`;
  }
  if (fileUpload.fileDescriptor?.path) {
    link = `${config.apiUrl}${fileUpload.fileDescriptor?.path}`;
  }
  return link;
};

export async function getFileLink(fileDescriptor: FileDescriptor): Promise<unknown> {
  return await api.download(`${config.apiUrl}${fileDescriptor.path}`);
}

export function getMimeType(contentType: string): MimeTypeKeys {
  return contentType.split('/')[0] as MimeTypeKeys;
}

export function getFileExtension(fileName: string): string {
  const extension = fileName.split('.').pop();
  if (extension === fileName) {
    return '';
  }
  return extension || '';
}

export function isImage(mimeType: string): boolean {
  return getFileType(mimeType) === FileTypes.image;
}

export function isVideo(mimeType: string): boolean {
  return getFileType(mimeType) === FileTypes.video;
}

export function isAudio(mimeType: string): boolean {
  return getFileType(mimeType) === FileTypes.audio;
}

export function isDefaultFile(mimeType: string): boolean {
  return getFileType(mimeType) === FileTypes.defaultFile;
}

export const isMaxAllowedSize = (fileSize: number): boolean => {
  const maxFileSize = MAX_FILE_SIZE_MB * 1024 ** 2;
  return fileSize > maxFileSize;
};

export const hasMaxAllowedSize = (files: FileDescriptor[], addedFile: File): boolean => {
  const totalFileSize = files.map((x) => x.fileSize).reduce((el, acc) => el + acc, 0);
  return isMaxAllowedSize(addedFile.size + totalFileSize);
};

export const downloadOnClick = async (file: FileDescriptor): Promise<void> => {
  const result = await getFileLink(file);
  downloadFile(result as DownloadFileType);
};
